import React, { useState } from 'react'
import IconButton from '../../../components/Buttons/IconButton';
import { Modal } from 'react-bootstrap';
import { IconCalendarTime, IconX } from '@tabler/icons-react';
import { loadingHide, loadingShow } from '../../../loadingUi/loading.controller';
import { postApi } from '../../../api/call.api';
import { urlApi } from '../../../api/url.api';
import { toast } from 'sonner';

const ScheduleExpireLinkModal = ({ baseData, callback }) => {

    const [show, setShow] = useState(false);
    const [date, setDate] = useState(baseData?.expiryTime?.split("T")[0] || "");
    const [hour, setHour] = useState(baseData?.expiryTime?.split("T")[1]?.split(":")[0] || "");

    const handleDateChange = (e) => {
        setDate(e.target.value);
    };

    const handleHourChange = (e) => {
        setHour(e.target.value);
    };
    const handleClose = () => {
        setShow(false)
    };
    const handleShow = () => setShow(true);

    const formatHour = (hour24) => {
        const hour = parseInt(hour24, 10);
        const isAM = hour < 12;
        const formattedHour = hour % 12 || 12;
        const ampm = isAM ? "AM" : "PM";
        return `${formattedHour}:00 ${ampm}`;
    };

    const submit = async () => {
        loadingShow();
        let postData = {
            linkId: baseData?._id,
            expiryLinkFallback: document.getElementById("expiryLink").value,
            expiryTime: `${date} ${(hour)}:00:00`,
        }
        let resp = await postApi(postData, urlApi?.setLinkExpiration);
        loadingHide();
        if (resp.responseCode === 200) {
            toast.success(resp?.message);
            callback?.();
            handleClose();
        } else {
            toast.error(resp?.message);
        }
    }

    return (
        <>
            <IconButton icon={< IconCalendarTime size={16} />} text={"Schedule"} onClickFunction={() => handleShow()} />
            {show && <Modal show={show} onHide={handleClose} size='lg' centered backdrop="static" >
                <Modal.Body className='rounded-xl'>
                    <div className="flex justify-between items-center">
                        <p className="text-md font-semibold">Update Destination Link</p>
                        <IconX className='cursor-pointer' onClick={handleClose} />
                    </div>
                    <hr className='my-3' />
                    <p className='text-xs font-normal italic mb-4 text-center text-orange-600'>Now, you can set an expiration time for your link! Once the time is reached, the original link will expire, and users will be redirected to a fallback link.</p>
                    <p className='text-xs font-normal italic mb-4 text-center text-orange-600'><b>✅ How It Works:</b><br />

                        <strong>Set an Expiry Time -</strong> Define when the original link should stop working. <br />
                        <strong>Auto Expiration -</strong> After the set time, the original link becomes inactive. <br />
                        <strong>Fallback Activation -</strong> Users will be automatically redirected to the fallback link. <br /> <br />
                        ⚡ Keep your links dynamic and always accessible! Set up your fallback link today. 🚀</p>

                    <div className='mb-3'>
                        <label htmlFor="expiryLink" className='text-sm font-semibold mb-1'>Fallback Link</label>
                        <input type='text' id='expiryLink' className='w-full px-3 py-2 rounded-md border-2 text-sm' placeholder='Type Your Fallback Link Here' defaultValue={baseData?.expiryLinkFallback} />
                    </div>

                    <div className='mb-4'>
                        <label htmlFor="" className='text-sm font-semibold mb-1'>Expiry Date & Time</label>
                        <div className='grid grid-cols-1 md:grid-cols-2 gap-3'>

                            <input type='date' id='expiry-time' className='w-full px-3 py-2 rounded-md border-2 text-sm' onChange={handleDateChange} defaultValue={baseData?.expiryTime?.split("T")[0]} />

                            <select
                                defaultValue={baseData?.expiryTime ? baseData?.expiryTime?.split("T")[1]?.split(":")[0] : ""}
                                onChange={handleHourChange}
                                className="w-full px-3 py-2 rounded-md border-2 text-sm"
                            >
                                <option value="" disabled>Select Hour</option>
                                {[...Array(24)].map((_, i) => (
                                    <option key={i} value={i.toString().padStart(2, "0")}>
                                        {formatHour(i.toString().padStart(2, "0"))}
                                    </option>
                                ))}
                            </select>
                        </div>
                    </div>

                    <hr className='my-3' />
                    <div className='flex justify-end gap-3'>
                        <button className='cancel-btn' onClick={handleClose}>Cancel</button>
                        <button className='primary-btn' onClick={() => submit()}>Schedule</button>
                    </div>
                </Modal.Body>
            </Modal>}
        </>
    )
}

export default ScheduleExpireLinkModal